import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../theme";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import EmojiEventsIcon from "@mui/icons-material/EmojiEvents"; // 24K
import DiamondIcon from "@mui/icons-material/Diamond"; // 22K
import StarIcon from "@mui/icons-material/Star"; // 21K
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"; // 18K
import CategoryIcon from "@mui/icons-material/Category"; // Default

const StatBox = ({ title, subtitle, priceData }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { current, previous } = priceData;
  const isMobile = useMediaQuery("(max-width:600px)");

  const isPriceIncreased = current > previous;

  const priceChangeIcon = isPriceIncreased ? (
    <ArrowUpwardIcon
      sx={{
        color: colors.greenAccent[500],
        fontSize: isMobile ? "20px" : "28px",
      }}
    />
  ) : (
    <ArrowDownwardIcon
      sx={{
        color: colors.redAccent[500],
        fontSize: isMobile ? "20px" : "28px",
      }}
    />
  );

  // ✅ تحديد الأيقونة حسب العيار
  const getIconForKarat = (karat) => {
    switch (karat) {
      case "24K":
        return (
          <EmojiEventsIcon
            sx={{ color: "#FFD700", fontSize: isMobile ? "20px" : "50px" }}
          />
        );
      case "22K":
        return (
          <DiamondIcon
            sx={{ color: "#B9F2FF", fontSize: isMobile ? "20px" : "50px" }}
          />
        );
      case "21K":
        return (
          <StarIcon
            sx={{ color: "#FFC107", fontSize: isMobile ? "20px" : "50px" }}
          />
        );
      case "18K":
        return (
          <AttachMoneyIcon
            sx={{ color: "#4CAF50", fontSize: isMobile ? "20px" : "50px" }}
          />
        );
      default:
        return <CategoryIcon sx={{ fontSize: isMobile ? "20px" : "50px" }} />;
    }
  };

  return (
    <Box
      width="100%"
      height="100px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Box display="flex" alignItems="center" gap="10px" mb="6px" ml="10px">
        {getIconForKarat(subtitle.replace("عيار ", ""))}
        <Typography
          fontWeight="bold"
          sx={{
            color: colors.grey[100],
            fontSize: isMobile ? "20px" : "35px",
          }}
        >
          {title}
        </Typography>
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px="20px"
      >
        <Typography
          sx={{
            color: isPriceIncreased
              ? colors.greenAccent[500]
              : colors.redAccent[500],
            fontSize: isMobile ? "16px" : "25px",
            fontWeight: "bold",
          }}
        >
          {subtitle}
        </Typography>
        {priceChangeIcon}
      </Box>
    </Box>
  );
};

export default StatBox;
